@if (timeDuration) {
  {{ timeDuration }} {{ 'fired.table.mins' | transloco }}
} @else {
  -
}
